import { action, thunk, persist } from 'easy-peasy';
import { httpGetFrontpageInfo } from "services/frontpageInfo"

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  frontpageInfo: [],
  setFrontpageInfo: action((state, payload) => {
    state.frontpageInfo = payload
  }),
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  getFrontpageInfo: thunk(async (actions, payload) => {
    actions.setLoading(true)
    httpGetFrontpageInfo().then(response => {
      if (response?.data) {
        actions.setFrontpageInfo(response?.data)
        actions.setCount(response?.data.length) 
      }
    }, error => {
      console.log(error)
    }).finally(() => {
      actions.setLoading(false)
    })
    
  }),
};

export default model;